module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('data-form', {
    attrs: {
      "model": "users",
      "entity": _vm.user,
      "fields": _vm.fields,
      "after-submit": _vm.afterSubmit,
      "ignoreEntityChanges": ""
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-59cf48d6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/UserForm.vue
// module id = 1004
// module chunks = 2